import { useEffect, useState } from "react";
import styles from "../Dashoard.module.css";
import { Box, Container, Grid } from "@mui/material";
import StudentInfo from "./StudentInfo";
import RecentCourses from "./RecentCourses";
import GetStarted from "./GetStarted";
import ReminderSection from "./ReminderSection";
import Calendar from "./Calendar";
import SelectForm from "./SelectForm";
import Overview from "./Overview";
import CourseName from "./CourseName";
import Courses from "./Courses";
import LearnersTBD from "./LearnersTBD";
import { apiRequest } from "../../../utils/axiosInstance";
import SimpleBackdrop from "../../Backdrop/SimpleBackdrop";
import { useDispatch, useSelector } from "react-redux";
import { setActiveCourseId } from "../../../redux/dashboardSlice";
import { NextSeo } from "next-seo";
import axios from "axios";

const LearnerDashBoard = (props) => {
  const dispatch = useDispatch();
  const activeOrgId = useSelector((state) => state.org.activeOrgId);

  useEffect(() => {
    const userAuthenticated = localStorage.getItem("userAuthenticated");
    const orgId = localStorage.getItem("orgId");
    const baseUrl = window.location.origin;
    if (!userAuthenticated || !orgId || !(orgId > 0)) {
      window.location.href = baseUrl;
    }

    getStudentNumber();
    getRecentCourses();
    getAllCoursesSalesInfo();
    getMaxPriceSoldCourses();
    getGetUpcomingSessions();
    getSingleCourseSalesInfo();
    getIsStripeConnectedForOrg();
    getIsTeachingPageSetupCompleted();
    getIsStripeCompletedOrNot();
    getAllCoursesBasicInfoList();
    getAllCoursesEnrollmentInfo();
    getSingleCourseEnrollmentInfo();
  }, [activeOrgId]);

  const [range, setRange] = useState("weekly");
  const [sessionsUpcoming, setSessionsUpcoming] = useState(null);
  const [maxPriceSoldCourses, setMaxPriceSoldCourses] = useState(null);
  const [allCoursesSalesInfo, setAllCoursesSalesInfo] = useState(null);
  const [lastTwoRecentCourses, setLastTwoRecentCourses] = useState([]);
  const [singleCourseSalesInfo, setSingleCourseSalesInfo] = useState(null);
  const [isStripeConnectedForOrg, setIsStripeConnectedForOrg] = useState(null);

  const [isStripeCompleted, setIsStripeCompleted] = useState(null);
  const [isSetupTeachingPageCompleted, setIsSetupTeachingPageCompleted] =
    useState(false);
  const [hasCourses, setHasCourses] = useState(null);
  const [allCoursesEnrollmentInfo, setAllCoursesEnrollmentInfo] =
    useState(null);
  const [singleCourseEnrollmentInfo, setSingleCourseEnrollmentInfo] =
    useState(null);
  const [studentNumber, setStudentNumber] = useState(0);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  /**
   * close backdrop
   */
  const handleCloseBackdrop = () => {
    setOpenBackdrop(false);
  };
  const [allCoursesBasicInfoList, setAllCoursesBasicInfoList] = useState([]);
  const [selectedSingleCourseActive, setSelectedSingleCourseActive] =
    useState(null);

  useEffect(() => {
    const userAuthenticated = localStorage.getItem("userAuthenticated");
    const orgId = localStorage.getItem("orgId");
    const baseUrl = window.location.origin;
    if (!userAuthenticated || !orgId || !(orgId > 0)) {
      window.location.href = baseUrl;
    }

    getStudentNumber();
    getRecentCourses();
    getAllCoursesSalesInfo();
    getMaxPriceSoldCourses();
    getGetUpcomingSessions();
    getSingleCourseSalesInfo();
    getIsStripeConnectedForOrg();
    getIsTeachingPageSetupCompleted();
    getAllCoursesBasicInfoList();
    getAllCoursesEnrollmentInfo();
    getSingleCourseEnrollmentInfo();
  }, []);

  useEffect(() => {
    getGetUpcomingSessions();
    getMaxPriceSoldCourses();
    getAllCoursesSalesInfo();
    getSingleCourseSalesInfo();
    getAllCoursesBasicInfoList();
    getAllCoursesEnrollmentInfo();
    getSingleCourseEnrollmentInfo();
  }, [range]);

  useEffect(() => {
    if (
      selectedSingleCourseActive !== null &&
      selectedSingleCourseActive !== undefined
    ) {
      getSingleCourseSalesInfo();
      getSingleCourseEnrollmentInfo();
      // console.log(selectedSingleCourseActive, 609);
    }
  }, [selectedSingleCourseActive]);

  const getStudentNumber = async () => {
    let orgId = localStorage.getItem("orgId");
    try {
      const data = await apiRequest(
        `/orgPortal/getStudentNumberOfAnOrganization?orgId=${orgId}`,
        "GET",
        null,
      );

      if (!data?.error) {
        setStudentNumber(data?.data?.studentNumber);
      }
    } catch (error) {
      setStudentNumber(0);
    }
  };
  const getAllCoursesBasicInfoList = async () => {
    let orgId = localStorage.getItem("orgId");
    let postData = {
      orgId,
    };
    try {
      const data = await apiRequest(
        "/orgPortal/getBasicCoursesInfoOfAnOrganization",
        "POST",
        postData,
      );

      if (data?.data) {
        setAllCoursesBasicInfoList(data?.data);
      }
    } catch (error) {
      setAllCoursesBasicInfoList([]);
    }
  };
  const createOrGetAccountLinkHandler = async () => {
    let orgId = localStorage.getItem("orgId");
    const baseUrl = window.location.origin;
    const selected_country_for_stripe_connect = localStorage.getItem(
      "selected_country_for_stripe_connect",
    );
    let postData = {
      return_url: `${baseUrl}/teaching-home`,
      refresh_url: `${baseUrl}/stripe-connected`,
      selected_country_for_stripe_connect: selected_country_for_stripe_connect,
      orgId: orgId,
    };
    setOpenBackdrop(true);
    try {
      const data = await apiRequest(
        "/orgPortal/createOrGetAccountLink",
        "POST",
        postData,
      );

      if (data?.data) {
        console.log(data?.data?.accountUrlInfo);
        window.open(data?.data?.accountUrlInfo?.url, "_blank");
        // setAllCoursesSalesInfo(data?.data)
      }
      setOpenBackdrop(false);
    } catch (error) {
      console.log(error);
      setOpenBackdrop(false);
      // setAllCoursesSalesInfo(null)
    }
  };
  const getAllCoursesSalesInfo = async () => {
    let orgId = localStorage.getItem("orgId");

    let postData = {
      range: range, //weekly, monthly, yearly
      orgId: orgId,
    };
    setOpenBackdrop(true);
    try {
      const data = await apiRequest(
        "/orgPortal/allCoursesSalesInfo",
        "POST",
        postData,
      );

      if (data?.data) {
        setAllCoursesSalesInfo(data?.data);
      }
      setOpenBackdrop(false);
    } catch (error) {
      setAllCoursesSalesInfo(null);
      setOpenBackdrop(false);
    }
  };

  const getSingleCourseSalesInfo = async () => {
    let orgId = localStorage.getItem("orgId");
    let postData = {
      range: range, //weekly, monthly, yearly
      courseId: selectedSingleCourseActive,
      orgId,
    };
    setOpenBackdrop(true);
    dispatch(setActiveCourseId(null));
    try {
      const data = await apiRequest(
        "/orgPortal/singleCourseSalesInfo",
        "POST",
        postData,
      );

      if (data?.data) {
        setSingleCourseSalesInfo(data?.data);
        dispatch(setActiveCourseId(data?.data?.course_id));
      }
      setOpenBackdrop(false);
    } catch (error) {
      setSingleCourseSalesInfo([]);
      setOpenBackdrop(false);
    }
  };

  const getAllCoursesEnrollmentInfo = async () => {
    let orgId = localStorage.getItem("orgId");
    let postData = {
      range: range, //weekly, monthly, yearly
      orgId: orgId,
    };
    setOpenBackdrop(true);
    try {
      const data = await apiRequest(
        "/orgPortal/allCoursesEnrollmentInfo",
        "POST",
        postData,
      );

      if (data?.data) {
        setAllCoursesEnrollmentInfo(data?.data);
      }
      setOpenBackdrop(false);
    } catch (error) {
      setAllCoursesEnrollmentInfo(null);
      setOpenBackdrop(false);
    }
  };

  const getSingleCourseEnrollmentInfo = async () => {
    let orgId = localStorage.getItem("orgId");
    let postData = {
      range: range, // weekly, monthly
      courseId: selectedSingleCourseActive,
      orgId,
    };
    setOpenBackdrop(true);
    try {
      const data = await apiRequest(
        "/orgPortal/singleCourseEnrollmentInfo",
        "POST",
        postData,
      );

      if (data?.data) {
        setSingleCourseEnrollmentInfo(data?.data);
      }
      setOpenBackdrop(false);
    } catch (error) {
      setSingleCourseEnrollmentInfo([]);
      setOpenBackdrop(false);
    }
  };

  const getMaxPriceSoldCourses = async () => {
    let orgId = localStorage.getItem("orgId");
    let postData = {
      range: range, // "monthly", "weekly", "yearly"
      orgId: orgId,
    };
    setOpenBackdrop(true);
    try {
      const data = await apiRequest(
        "/orgPortal/maxPriceSoldCourses",
        "POST",
        postData,
      );

      if (data?.data) {
        setMaxPriceSoldCourses(data?.data?.coursesWithSoldPrices);
      }
      setOpenBackdrop(false);
    } catch (error) {
      setMaxPriceSoldCourses([]);
      setOpenBackdrop(false);
    }
  };

  const getGetUpcomingSessions = async () => {
    let orgId = localStorage.getItem("orgId");
    let postData = {
      range: range, // "monthly", "weekly", "yearly"
      orgId: orgId,
    };
    setOpenBackdrop(true);
    try {
      const data = await apiRequest(
        "/orgPortal/getUpcomingSessions",
        "POST",
        postData,
      );

      if (data?.data?.sessions) {
        setSessionsUpcoming(data?.data?.sessions);
      }
      setOpenBackdrop(false);
    } catch (error) {
      setSessionsUpcoming([]);
      setOpenBackdrop(false);
    }
  };

  const getIsStripeConnectedForOrg = async () => {
    let orgId = localStorage.getItem("orgId");

    let postData = {
      orgId: orgId || 5,
    };
    setOpenBackdrop(true);
    try {
      const data = await apiRequest(
        "/orgPortal/isStripeConnectedForOrg",
        "POST",
        postData,
      );

      if (data?.data) {
        setIsStripeConnectedForOrg(data?.data?.isConnected);
      }
      setOpenBackdrop(false);
    } catch (error) {
      console.log(error);
      setIsStripeConnectedForOrg(false);
      setOpenBackdrop(false);
    }
  };
  const getIsTeachingPageSetupCompleted = async () => {
    const orgId = localStorage.getItem("orgId");
    const jwtToken = localStorage.getItem("jwtToken");
    setOpenBackdrop(true);
    try {
      const response = await axios.get(
        `${process.env.NEXT_PUBLIC_TEACHER_SETTING_API_URL}/taupdate/v1/private/getDetails/${orgId}`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        },
      );
      const organization = response.data;
      if (organization !== "") {
        const isCompleted =
          (organization?.name ?? "").trim() !== "" &&
          (organization?.shortDescription ?? "").trim() !== "" &&
          ((organization?.logoImageUrl ?? "").trim() !== "" &&
            (organization?.about ?? "").trim()) !== "" &&
          (organization?.aboutImageUrl ?? "").trim() !== "" &&
          (organization?.aboutTitle ?? "").trim() !== "" &&
          (organization?.subtitle ?? "").trim() !== "";

        setIsSetupTeachingPageCompleted(isCompleted);
      } else {
        setIsSetupTeachingPageCompleted(false);
      }
      // console.log(609, organization);
      setOpenBackdrop(false);
    } catch (error) {
      console.log(error);
      setOpenBackdrop(false);
    }
  };

  const getIsStripeCompletedOrNot = async () => {
    let orgId = localStorage.getItem("orgId");

    let postData = {
      orgId: orgId,
    };
    setOpenBackdrop(true);
    try {
      const data = await apiRequest(
        "/orgPortal/checkStripeAccountCompletion",
        "POST",
        postData,
      );

      if (data?.data) {
        setIsStripeCompleted(data?.data?.isCompleted);
      }
      setOpenBackdrop(false);
    } catch (error) {
      console.log(error);
      setIsStripeCompleted(false);
      setOpenBackdrop(false);
    }
  };

  const getRecentCourses = async () => {
    let orgId = localStorage.getItem("orgId");

    setOpenBackdrop(true);
    try {
      const data = await apiRequest("/orgPortal/getLastTwoVisits", "POST", {
        orgId,
      });

      if (data?.data) {
        setLastTwoRecentCourses(data?.data?.courseVisitInfo);
      }
      setOpenBackdrop(false);
    } catch (error) {
      setLastTwoRecentCourses([]);
      setOpenBackdrop(false);
      // setSliderInfo([])
    }
  };

  return (
    <>
      <NextSeo title="Takbir | Teaching Account" />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <StudentInfo />
        </Grid>

        <Grid item xs={12} sm={12}>
          <SelectForm range={range} setRange={setRange} />
          <GetStarted
            isStripeConnectedForOrg={
              isStripeConnectedForOrg || isStripeCompleted
            }
            createOrGetAccountLinkHandler={createOrGetAccountLinkHandler}
            isSetupTeachingPageCompleted={isSetupTeachingPageCompleted}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Overview
                allCoursesSalesInfo={allCoursesSalesInfo}
                allCoursesEnrollmentInfo={allCoursesEnrollmentInfo}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <ReminderSection
                sessionsUpcoming={sessionsUpcoming}
                studentNumber={studentNumber}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  {/* <ReminderSection sessionsUpcoming={sessionsUpcoming} /> */}
                  <Courses
                    maxPriceSoldCourses={maxPriceSoldCourses}
                    setHasCourses={setHasCourses}
                  />
                </Grid>

                {/* <Grid item xs={12} sm={6}>
                  <LearnersTBD />
                </Grid> */}
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <CourseName
                singleCourseSalesInfo={singleCourseSalesInfo}
                allCoursesBasicInfoList={allCoursesBasicInfoList}
                singleCourseEnrollmentInfo={singleCourseEnrollmentInfo}
                setSelectedSingleCourseActive={setSelectedSingleCourseActive}
                hasCourses={hasCourses}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <Calendar sessionsUpcoming={sessionsUpcoming} />
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <RecentCourses lastTwoRecentCourses={lastTwoRecentCourses} />
        </Grid>
      </Grid>
      <SimpleBackdrop open={openBackdrop} handleClose={handleCloseBackdrop} />
    </>
  );
};

export default LearnerDashBoard;
